import { Currency } from '@/core/currency/interfaces';

const PHP: Currency = {
    name: 'Philippine Peso',
    demonym: 'Philippine',
    majorSingle: 'Peso',
    majorPlural: 'Pesos',
    codeNumeric: '608',
    symbol: '₱',
    symbolNative: '₱',
    minorSingle: 'Sentimo',
    minorPlural: 'Sentimo',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'PHP',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default PHP;
